import { Input, InputProps } from "antd-mobile";
export const InputNumber = (props: InputProps) => {
  return <Input {...props} data-sentry-element="Input" data-sentry-component="InputNumber" data-sentry-source-file="index.tsx" />;
};